import { IconButton, IconName } from '@focaldata/cin-ui-components'
import React, { useState } from 'react'
import { MediaType } from '../../../data/model/questionnaire'
import RowMediaUploader from '../MediaUploader/MediaUploader'

interface Props {
  questionnaireId: string
  attributeId: string
  optionId: string
  media: {
    mediaUrl: string
    mediaType: MediaType
    renderedMediaUrl?: string | null
  } | null
  onUpload: (
    attributeId: string,
    optionId: string,
    mediaUrl: string,
    mediaName: string,
    mediaType: MediaType,
    renderedMediaUrl: string
  ) => Promise<void>
  onRemove: (attributeId: string, optionId: string) => Promise<void>
}

// Per-value image control for the appearance attribute, reusing the same
// tus-upload/resize uploader as response option images (image-only, 5MB).
export const ConjointAttributeValueMedia: React.FC<Props> = ({
  questionnaireId,
  attributeId,
  optionId,
  media,
  onUpload,
  onRemove
}) => {
  const [isImageDialogOpened, setIsImageDialogOpened] = useState(false)

  return (
    <>
      {!media && (
        <div data-testid={`add-image-${attributeId}-${optionId}`}>
          <IconButton
            iconName={IconName.Image}
            onClick={() => setIsImageDialogOpened(true)}
            smallHoverShadowSize
          />
        </div>
      )}
      <RowMediaUploader
        questionnaireId={questionnaireId}
        questionLk={attributeId}
        responseOptionLk={optionId}
        mediaUrl={media?.mediaUrl}
        renderedMediaUrl={media?.renderedMediaUrl}
        mediaType={media?.mediaType}
        imageDialogOpened={isImageDialogOpened}
        onDialogClose={() => setIsImageDialogOpened(false)}
        onMediaUpload={async (
          _questionnaireId,
          questionLk,
          responseOptionLk,
          mediaUrl,
          mediaName,
          mediaType,
          renderedMediaUrl
        ) => {
          // Awaited and propagated — not fire-and-forget — so RowMediaUploader's
          // own try/catch can surface a failed save via its error state instead
          // of the upload looking successful when the mutation actually failed.
          await onUpload(
            questionLk,
            responseOptionLk,
            mediaUrl,
            mediaName,
            mediaType,
            renderedMediaUrl
          )
        }}
        onRemoveMedia={async (questionLk, responseOptionLk) => {
          await onRemove(questionLk, responseOptionLk)
        }}
      />
    </>
  )
}
